import type { OpenPixConfig } from '../openPixState.tsx';
import { setOpenPixState } from '../openPixState.tsx';

// $openpix.push(["config", { appID: 'myAppId' })
export const configureApiID = (config: OpenPixConfig) => {
  if (config?.appID) {
    setOpenPixState({
      config,
    });
  }
};
